import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { PageHeader } from '@/components/ui/PageHeader'
import { Suspense } from 'react'
// import { GridTableToggle } from '@/pages/Applications/ApplicationsHome/GridTableToggle'
import { Outlet } from 'react-router'
import { FeaturedAppsGrid, FeaturedAppsGridLoading } from './FeaturedAppsGrid'

export function FeaturedApps() {
  return <Outlet />
}

export function FeaturedAppsContent() {
  return (
    <div className="px-5">
      <PageHeader title="Featured Apps">
        {/* <GridTableToggle value={view} onChange={setView} className="hidden" /> */}
      </PageHeader>
      <QueryErrorBoundary errorMessage="Failed to fetch applications">
        <TablePageContainer>
          <Suspense fallback={<FeaturedAppsGridLoading />}>
            <FeaturedAppsGrid />
          </Suspense>
        </TablePageContainer>
      </QueryErrorBoundary>
    </div>
  )
}
